import { render, staticRenderFns } from "./CreateInvoiceModal.vue?vue&type=template&id=3908eeee&"
import script from "./CreateInvoiceModal.vue?vue&type=script&lang=js&"
export * from "./CreateInvoiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports